// src/pages/Customer/CustomerViewPage.jsx
import React, { useState } from "react";
import { Button, Card, Col, Descriptions, Row, Table, Tag } from "antd";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { customerStats } from "../../constants/API/API";
import { useParams } from "react-router";
import { Severty, ShowToast } from "../../helper/toast";
import lang from "../../helper/langHelper";

const columns = [
  {
    title: "Booking ID",
    dataIndex: "bookingId",
    key: "bookingId",
    render: (_, { bookingId }) => bookingId || "-",
  },
  {
    title: "Parent",
    dataIndex: "user",
    key: "user",
    render: (text, record) => record?.userId?.name || "-",
  },
  {
    title: "Class",
    dataIndex: "class",
    key: "class",
    render: (text, record) => record?.classId?.name || "-",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    key: "branch",
    render: (text, record) => record?.branchId?.name || "-",
  },
  {
    title: "Trainer",
    dataIndex: "trainer",
    key: "trainer",
    render: (text, record) => record?.trainerId?.name || "-",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (text, record) =>
      record?.date ? moment(record?.date).format("ll") : "-",
  },
  {
    title: "Time Slot",
    dataIndex: "slot",
    key: "slot",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (_, record) => <Tag>{record?.status}</Tag>,
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (text) => (text ? new Date(text).toLocaleDateString() : "-"),
  },
];

const CustomerViewPage = () => {
  const [student, setStudent] = useState();
  const { id } = useParams();

  useApi({
    callback: customerStats,
    payload: id,
    dependencies: [id],
    shouldCallApi: true,
    onSuccess: (data) => {
      setStudent(data);
    },
    onError: (err) => {
      ShowToast(err, Severty.ERROR);
    },
  });

  return (
    <div>
      <Button
        type="default"
        className="mb-2"
        style={{ color: "black" }}
        onClick={() => window.history.back()}
      >
        Back
      </Button>

      <Card title="Student Overview" className="mb-4">
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Name">
            {student?.user?.name || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {student?.user?.email || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Mobile">
            {student?.user?.countryCode && student?.user?.mobileNumber
              ? `${student?.user?.countryCode?.includes("+") ? "" : "+"}${
                  student?.user?.countryCode
                } ${student?.user?.mobileNumber}`
              : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Role">
            {student?.user?.roleType}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={!student?.user?.isActive ? "red" : "green"}>
              {!!student?.user?.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Joined">
            {moment(student?.user?.created_at).format("ll")}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          {/* kyu progress */}
          <Card title={lang("Kyu Progress")}>
            <Descriptions bordered column={1}>
              <Descriptions.Item label={lang("Kyu Start Date")}>
                {student?.kyuProgress?.kyuStartDate
                  ? moment(student?.kyuProgress?.kyuStartDate).format(
                      "DD-MM-YYYY"
                    )
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item label={lang("Total Classes")}>
                {student?.kyuProgress?.totalClasses ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label={lang("Attended Classes")}>
                {student?.kyuProgress?.attendedClasses ?? "-"}
              </Descriptions.Item>
              <Descriptions.Item label={lang("Eligible")}>
                {student?.kyuProgress?.eligible ? "Yes" : "No"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        {/* Student Progress */}
        <Col span={12}>
          <Card title="Student Progress">
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Current Belt">
                {student?.progress?.beltId?.name}
              </Descriptions.Item>
              {/* <Descriptions.Item label="Total Classes Scheduled">
                {student?.progress?.attendedCount}
              </Descriptions.Item> */}
              <Descriptions.Item label="Required Classes">
                {student?.progress?.requiredClasses}
              </Descriptions.Item>
              <Descriptions.Item label="Attendance Count">
                {student?.progress?.classProgress?.[0]?.attendanceCount}
              </Descriptions.Item>
              <Descriptions.Item label="Eligible For Graduation">
                {!!student?.progress?.eligibleForGraduation ? "Yes" : "No"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>

      {/* Attendance History */}
      <Card title="Attendance History" className="mb-4 mt-4">
        <Table
          columns={columns}
          dataSource={student?.completedBookings || []}
          pagination={{current: 1, pageSize: 10, total: student?.completedBookings?.length}}
          rowKey="_id"
          bordered
          size="middle"
        />
      </Card>
    </div>
  );
};

export default CustomerViewPage;
